import { render, staticRenderFns } from "./new-bucket-folder.html?vue&type=template&id=ce6a8f30&scoped=true&external"
import script from "./new-bucket-folder.js?vue&type=script&lang=js&external"
export * from "./new-bucket-folder.js?vue&type=script&lang=js&external"
import style0 from "./new-bucket-folder.scss?vue&type=style&index=0&id=ce6a8f30&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6a8f30",
  null
  
)

export default component.exports